module.exports = __webpack_public_path__ + "static/media/SplashLogo.46adc63f.png";